class LLCustomerReviews {
  constructor(root) {
    if (root.dataset.llCrReady === 'true') return;
    root.dataset.llCrReady = 'true';
    this.root = root;
    this.list = root.querySelector('[data-ll-cr-list]');
    this.addImportedReviews();
    this.reviews = this.list ? [...this.list.querySelectorAll('[data-ll-cr-review]')] : [];
    this.pageSize = Number(root.dataset.pageSize) || 6;
    this.shown = this.pageSize;
    this.search = '';
    this.rating = 'all';
    this.mediaOnly = false;
    this.sort = 'recent';
    this.bind();
    this.render();
  }

  element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  stars(rating) {
    const stars = this.element('div', 'll-cr__stars');
    stars.setAttribute('aria-label', `${rating} out of 5 stars`);
    for (let value = 1; value <= 5; value += 1) {
      const star = this.element('span', value <= rating ? 'is-filled' : '', '★');
      stars.appendChild(star);
    }
    return stars;
  }

  addImportedReviews() {
    const imported = Array.isArray(window.LL_CUSTOMER_REVIEWS) ? window.LL_CUSTOMER_REVIEWS : [];
    if (!this.list || imported.length === 0) return;

    imported.forEach((review, index) => {
      const article = this.element('article', 'll-cr__review');
      article.dataset.llCrReview = '';
      article.dataset.index = String(imported.length - index);
      article.dataset.rating = String(review.rating);
      article.dataset.media = review.image ? '1' : '0';
      article.dataset.search = [review.author, review.title, review.body].filter(Boolean).join(' ').toLowerCase();

      const author = this.element('div', 'll-cr__review-author');
      author.appendChild(this.element('strong', '', review.author));
      if (review.verified) {
        const verified = this.element('span', 'll-cr__verified');
        verified.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
        verified.appendChild(document.createTextNode('Verified buyer'));
        author.appendChild(verified);
      }

      const content = this.element('div', 'll-cr__review-content');
      content.appendChild(this.stars(review.rating));
      if (review.title) content.appendChild(this.element('h3', '', review.title));
      content.appendChild(this.element('div', 'll-cr__review-text', review.body));
      if (review.image) {
        const photo = this.element('button', 'll-cr__photo');
        photo.type = 'button';
        photo.dataset.llCrPhoto = review.image;
        const image = this.element('img');
        image.src = review.image;
        image.alt = `${review.author} review photo`;
        image.loading = 'lazy';
        image.width = 164;
        image.height = 204;
        photo.appendChild(image);
        content.appendChild(photo);
      }

      const quality = this.element('div', 'll-cr__review-quality');
      quality.appendChild(this.element('span', '', 'Quality'));
      const bar = this.element('span', 'll-cr__bar');
      const fill = this.element('span');
      fill.style.width = `${review.quality}%`;
      bar.appendChild(fill);
      quality.appendChild(bar);
      quality.appendChild(this.element('small', '', review.qualityLabel));

      article.append(author, content, quality);
      this.list.appendChild(article);
    });
  }

  bind() {
    this.root.querySelector('[data-ll-cr-search]')?.addEventListener('input', (event) => {
      this.search = event.target.value.toLowerCase().trim();
      this.shown = this.pageSize;
      this.render();
    });
    this.root.querySelector('[data-ll-cr-rating]')?.addEventListener('change', (event) => {
      this.rating = event.target.value;
      this.shown = this.pageSize;
      this.render();
    });
    this.root.querySelector('[data-ll-cr-sort]')?.addEventListener('change', (event) => {
      this.sort = event.target.value;
      this.shown = this.pageSize;
      this.render();
    });
    const media = this.root.querySelector('[data-ll-cr-media]');
    media?.addEventListener('click', () => {
      this.mediaOnly = !this.mediaOnly;
      media.classList.toggle('is-active', this.mediaOnly);
      media.setAttribute('aria-pressed', String(this.mediaOnly));
      this.shown = this.pageSize;
      this.render();
    });
    this.root.querySelector('[data-ll-cr-load-more-button]')?.addEventListener('click', () => {
      this.shown += this.pageSize;
      this.render();
    });

    const formDialog = this.root.querySelector('[data-ll-cr-form-dialog]');
    this.root.querySelector('[data-ll-cr-open-form]')?.addEventListener('click', () => formDialog?.showModal());
    this.root.querySelector('[data-ll-cr-close-form]')?.addEventListener('click', () => formDialog?.close());

    const lightbox = this.root.querySelector('[data-ll-cr-lightbox]');
    const lightboxImage = this.root.querySelector('[data-ll-cr-lightbox-image]');
    this.root.addEventListener('click', (event) => {
      const photo = event.target.closest('[data-ll-cr-photo]');
      if (!photo || !lightbox || !lightboxImage) return;
      lightboxImage.src = photo.dataset.llCrPhoto;
      lightbox.showModal();
    });
    this.root.querySelector('[data-ll-cr-close-lightbox]')?.addEventListener('click', () => lightbox?.close());
  }

  filteredReviews() {
    const filtered = this.reviews.filter((review) => {
      if (this.rating !== 'all' && review.dataset.rating !== this.rating) return false;
      if (this.mediaOnly && review.dataset.media !== '1') return false;
      return !this.search || (review.dataset.search || '').includes(this.search);
    });
    return filtered.sort((a, b) => {
      if (this.sort === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || Number(b.dataset.index) - Number(a.dataset.index);
      if (this.sort === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || Number(b.dataset.index) - Number(a.dataset.index);
      return Number(b.dataset.index) - Number(a.dataset.index);
    });
  }

  render() {
    if (!this.list) return;
    const filtered = this.filteredReviews();
    this.reviews.forEach((review) => { review.hidden = true; });
    filtered.slice(0, this.shown).forEach((review) => {
      review.hidden = false;
      this.list.appendChild(review);
    });
    const results = this.root.querySelector('[data-ll-cr-results]');
    if (results) results.textContent = `${filtered.length} ${filtered.length === 1 ? 'review' : 'reviews'}`;
    const empty = this.root.querySelector('[data-ll-cr-empty]');
    if (empty) empty.hidden = filtered.length !== 0;
    const loadMore = this.root.querySelector('[data-ll-cr-load-more]');
    const loadMoreLabel = this.root.querySelector('[data-ll-cr-load-more-label]');
    if (loadMore) loadMore.hidden = filtered.length <= this.shown;
    if (loadMoreLabel) loadMoreLabel.textContent = `Showing ${Math.min(this.shown, filtered.length)} of ${filtered.length}`;
  }
}

const initLLCustomerReviews = (scope = document) => {
  scope.querySelectorAll('[data-ll-customer-reviews]').forEach((root) => new LLCustomerReviews(root));
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initLLCustomerReviews());
else initLLCustomerReviews();

document.addEventListener('shopify:section:load', (event) => initLLCustomerReviews(event.target));
